// extracted by mini-css-extract-plugin
module.exports = {"toc":"ArticleToc_toc__GxT2G","tocItem__header":"ArticleToc_tocItem__header__RQoDq"};